import React from 'react';
import PropTypes from 'prop-types';

import './spinner.css';

const Spinner = ({ color, scale }) => (
  <div className="spinner" style={{ transform: `scale(${scale})` }}>
    <div className="bounce1" style={{ backgroundColor: color }} />
    <div className="bounce2" style={{ backgroundColor: color }} />
    <div className="bounce3" style={{ backgroundColor: color }} />
  </div>
);

Spinner.propTypes = {
  color: PropTypes.string,
  scale: PropTypes.number,
};

Spinner.defaultProps = {
  color: 'rgba(255, 255, 255, 0.5)',
  scale: 1,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/index.jsx